export default "__VITE_ASSET__a604374b__"